import React from "react";
import { Link } from "react-router-dom";
import Therebelive from "./Therebelive";
import Aboutpeople from "./Aboutpeople";
const body = ({aboutpeoples,therebelivedata,fullsection}) => {
  
  return (
    <section>
      <Therebelive therebelivedata={therebelivedata}/>    
<section className="fullsection"><div className="container">
  {fullsection.text.map((textsection,index) => (
     <div className="managment-wrapper d-flex">
      {Array.isArray(textsection) && textsection.length > 0? <div><h3>{textsection[0]}</h3><p>{textsection[1]}</p></div> : <p>{textsection}</p> }
      
     </div>
  ))}
  </div>
</section>
<section className="our-management-section">
    <div className="container">
        <div className="managment-wrapper d-flex">
        {aboutpeoples.map((aboutpeople,index) => (
            <Aboutpeople key={index} peopledetails={aboutpeople} />
        ))}
        
        </div>
    </div>
</section>

    </section>
  );
};

export default body;